import React, { Component } from "react"

import PropTypes from "prop-types";
import ReactEcharts from "echarts-for-react"

function PieChart(props) {
  // console.log(props);
  const getOption = () => {
    // console.log(props);
    return {
      title: {
        // text: 'test',
        // left: 'center',
        // textStyle: {
        //   color: '#999',
        //   fontWeight: 'normal',
        //   fontSize: 20
        // }
      },
      toolbox: {
        show: false,
      },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c} ({d}%)",
      },
      legend: {
        orient: "vertical", //horizontal
        left: "left",
        data: ["Urgent", "Medium", "Normal", "Event"],
        // "Mobile", "Others", "Desktop"
        textStyle: {
          color: ["#FFFFFF"],
        },
      },
      color: ["#FF0000", "#DE7332", "#DBFE6C", "#5DE7FD"], 
      // "#FF4545",#34c38f", "#50a5f1", "#556ee6"
      series: [
        {
          name: "Alarm Management",
          type: "pie",
          radius: "70%",
          center: ["50%", "50%"],
          data: [
            { value: props.dataAlarmUrgent, name: "Urgent" },
            { value: props.dataAlarmMedium, name: "Medium" },
            { value: props.dataAlarmNormal, name: "Normal" },
            { value: props.dataAlarmEvent, name: "Event" },
          ],
          selectedMode: 'single',
          avoidLabelOverlap: true,
          itemStyle: {
            emphasis: {
              shadowBlur: 15,
              shadowOffsetX: 0,
              // shadowColor: "rgba(0, 0, 0, 0.5)",
            },
            borderColor: "#FFFFFF",
            borderWidth: 0,
          },

          labelLine: {
            // length: 0,
            // length2: 50,
            // maxSurfaceAngle: 50
          },

          label: {
            fontSize: 17,
            // borderWidth: 1,
            // borderColor: "#FFFFFF",
            fontWeight: "bold",

            // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
            // backgroundColor: '#F6F8FC',
            // borderColor: '#8C8D8E',
            // borderWidth: 1,
            // borderRadius: 4,
            // rich: {
            //   a: {
            //     color: '#6E7079',
            //     lineHeight: 22,
            //     align: 'center'
            //   },
            //   hr: {
            //     borderColor: '#8C8D8E',
            //     width: '100%',
            //     borderWidth: 1,
            //     height: 0
            //   },
            //   b: {
            //     color: '#4C5058',
            //     fontSize: 14,
            //     fontWeight: 'bold',
            //     lineHeight: 33
            //   },
            //   per: {
            //     color: '#fff',
            //     backgroundColor: '#4C5058',
            //     padding: [3, 4],
            //     borderRadius: 4
            //   }
            // }
          },
        },
      ],

    }
  }

  // render() {
  return (
    <React.Fragment>
      <ReactEcharts style={{ height: "45vh", width: "40vw" }} option={getOption()} />
    </React.Fragment>
  )
  // }
}

PieChart.propTypes = {
  t: PropTypes.any,
  dataAlarmMedium: PropTypes.any,
  dataAlarmUrgent: PropTypes.any,
  dataAlarmNormal: PropTypes.any,
  dataAlarmEvent: PropTypes.any,
}

export default PieChart
